/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Type of restore. This value is a combination of the cloud provider, resource type, and restore method. `RESTORE_JOB_TYPE_UNSPECIFIED` is supported only in responses. 
*/
export enum RestoreJobType {
  RestoreJobTypeUnspecified = 'RESTORE_JOB_TYPE_UNSPECIFIED',
  AwsS3ObjectRestore = 'AWS_S3_OBJECT_RESTORE',
  AwsS3BucketRestore = 'AWS_S3_BUCKET_RESTORE',
  AwsEc2FileRestore = 'AWS_EC2_FILE_RESTORE',
  AwsEc2InstanceRestore = 'AWS_EC2_INSTANCE_RESTORE',
  AwsEc2AmiConvert = 'AWS_EC2_AMI_CONVERT',
  AwsEc2EbsVolumeRestore = 'AWS_EC2_EBS_VOLUME_RESTORE',
  AwsEc2EbsSnapshotConvert = 'AWS_EC2_EBS_SNAPSHOT_CONVERT',
  AwsEc2RecordRestore = 'AWS_EC2_RECORD_RESTORE',
  AwsEbsVolumeRestore = 'AWS_EBS_VOLUME_RESTORE',
  AwsEbsSnapshotConvert = 'AWS_EBS_SNAPSHOT_CONVERT',
  AwsRdsInstanceRestore = 'AWS_RDS_INSTANCE_RESTORE',
  AwsRdsRecordRestore = 'AWS_RDS_RECORD_RESTORE',
  AwsEksNamespaceRestore = 'AWS_EKS_NAMESPACE_RESTORE',
  AwsEksNamespaceRecordRestore = 'AWS_EKS_NAMESPACE_RECORD_RESTORE',
  AwsEksFileRestore = 'AWS_EKS_FILE_RESTORE',
  AwsDynamoDbTableRestore = 'AWS_DYNAMO_DB_TABLE_RESTORE',
  AwsDynamoDbTableToExistingTableRestore = 'AWS_DYNAMO_DB_TABLE_TO_EXISTING_TABLE_RESTORE',
  AwsDynamoDbRecordRestore = 'AWS_DYNAMO_DB_RECORD_RESTORE',
  AzureStorageAccountRestore = 'AZURE_STORAGE_ACCOUNT_RESTORE',
  AzureStorageAccountBlobRestore = 'AZURE_STORAGE_ACCOUNT_BLOB_RESTORE',
  AzureVmFileRestore = 'AZURE_VM_FILE_RESTORE',
  AzureVmDiskRestore = 'AZURE_VM_DISK_RESTORE',
  AzureVmInstanceRestore = 'AZURE_VM_INSTANCE_RESTORE',
  AzureVmRecordRestore = 'AZURE_VM_RECORD_RESTORE',
  AzureSqlDatabaseRecordRestore = 'AZURE_SQL_DATABASE_RECORD_RESTORE',
  AzureSqlDatabaseRestore = 'AZURE_SQL_DATABASE_RESTORE',
  AzureSqlVmInstanceRestore = 'AZURE_SQL_VM_INSTANCE_RESTORE',
  AzureSqlVmRecordRestore = 'AZURE_SQL_VM_RECORD_RESTORE',
  AzureSapHanaVmInstanceRestore = 'AZURE_SAP_HANA_VM_INSTANCE_RESTORE',
  GcpCloudStorageBucketRestore = 'GCP_CLOUD_STORAGE_BUCKET_RESTORE',
  GcpCloudStorageObjectRestore = 'GCP_CLOUD_STORAGE_OBJECT_RESTORE',
  GcpComputeEngineFileRestore = 'GCP_COMPUTE_ENGINE_FILE_RESTORE',
  GcpComputeEngineDiskRestore = 'GCP_COMPUTE_ENGINE_DISK_RESTORE',
  GcpComputeEngineInstanceRestore = 'GCP_COMPUTE_ENGINE_INSTANCE_RESTORE',
  GcpComputeEngineRecordRestore = 'GCP_COMPUTE_ENGINE_RECORD_RESTORE',
  GcpCloudSqlDatabaseRestore = 'GCP_CLOUD_SQL_DATABASE_RESTORE',
  GcpCloudSqlRecordRestore = 'GCP_CLOUD_SQL_RECORD_RESTORE',
  GcpBigqueryDatasetRestore = 'GCP_BIGQUERY_DATASET_RESTORE',
  GcpBigqueryRecordRestore = 'GCP_BIGQUERY_RECORD_RESTORE',
  GcpBigqueryNativeRestoreDataset = 'GCP_BIGQUERY_NATIVE_RESTORE_DATASET',
  GcpBigqueryNativeRestoreTable = 'GCP_BIGQUERY_NATIVE_RESTORE_TABLE',
  RdsNativePitrRestore = 'RDS_NATIVE_PITR_RESTORE',
  AwsFsxRestore = 'AWS_FSX_RESTORE',
  AwsRedshiftRestore = 'AWS_REDSHIFT_RESTORE',
  GcpSapHanaVmInstanceRestore = 'GCP_SAP_HANA_VM_INSTANCE_RESTORE'
}
